module.exports = __webpack_public_path__ + "static/goffer-hex-gray-0eca4e228b05cdcaf059163fd26b4a82.png";